import styles from "./button.module.css";

export enum ButtonStyle {
	DARK = "dark",
	OUTLINE = "outline",
	WHITE = "white",
    LONG = "fullWidthBlack",
}

export interface ButtonProps {
	title: string;
	onClick?: () => void;
	rightIcon?: React.ReactNode;
	leftIcon?: React.ReactNode;
	style?: ButtonStyle;
	type?: "submit" | "button";
	disbaled?: boolean;
}

const Button: React.FC<ButtonProps> = ({ title, onClick, rightIcon, leftIcon, disbaled, style = ButtonStyle.DARK, type = "button" }) => {
	return (
		<button
			disabled={disbaled}
			type={type}
			onClick={onClick}
			className={`standardButton ${styles.submitButton} ${styles[style]} ${styles.button} ${disbaled && styles.disableButton}`}
		>
			{rightIcon} {title} {leftIcon}
		</button>
	);
};

export default Button;
